// extracted by mini-css-extract-plugin
module.exports = {"heading-wrapper":"_9e1425b4d3--heading-wrapper--LLnXf"};